module.exports = __webpack_public_path__ + "static/media/logotipo-white.545ab22f.png";